import { uniqueId } from 'cadenza/utils/unique-id';

/** @deprecated Use a `<form-group>` to wire a control and its label. */
export function label(
  el: Element,
  {
    ariaLabel,
    ariaLabelledBy,
  }: {
    ariaLabel?: string;
    ariaLabelledBy?: string | Element;
  },
) {
  if (ariaLabel) {
    el.setAttribute('aria-label', ariaLabel);
  }
  if (ariaLabelledBy) {
    if (ariaLabelledBy instanceof Element) {
      if (!ariaLabelledBy.id) {
        ariaLabelledBy.id = uniqueId();
      }
      ariaLabelledBy = ariaLabelledBy.id;
    }
    el.setAttribute('aria-labelledby', ariaLabelledBy);
  }
}

export function ariaTrueFalse(el: Element, property: string): boolean;
export function ariaTrueFalse(el: Element, property: string, value: boolean): void;
export function ariaTrueFalse(el: Element, property: string, value?: boolean) {
  const attribute = `aria-${property}`;
  if (arguments.length === 2) {
    // get
    return el.getAttribute(attribute) === 'true';
  }

  // set
  if (value) {
    el.setAttribute(attribute, String(value));
  } else {
    el.removeAttribute(attribute);
  }
}

export function ariaTristate(el: Element, property: string): boolean;
export function ariaTristate(el: Element, property: string, value: boolean | 'mixed'): void;
export function ariaTristate(el: Element, property: string, value?: boolean | 'mixed') {
  const attribute = `aria-${property}`;
  if (arguments.length === 2) {
    // get
    const attributeValue = el.getAttribute(attribute);
    if (attributeValue === 'true') {
      return true;
    }
    if (attributeValue === 'false') {
      return false;
    }
    return 'mixed';
  }

  // set
  el.setAttribute(attribute, String(value));
}
